export default __webpack_public_path__ + "static/media/themesberg-logo.b05534a6.svg";